import React, { useCallback, useState } from "react";
import { useDispatch } from "react-redux";
import { OverlayTrigger, Popover } from "react-bootstrap";
import { FaIcon as Fa } from "lib/FaIcon";
import { CopyTextModal } from "../../copyText/CopyTextModal";
import { ShareContextMenu } from "./ShareContextMenu";
import "./shareButton.css";

export const ShareButton = ({ publication }) => {
  const dispatch = useDispatch();
  const [overlayShow, setOverlayShow] = React.useState(null);

  const handleHideHandler = useCallback(() => {
    setOverlayShow(false);
  }, [setOverlayShow]);

  const toggleHandler = useCallback(
    (nextShow) => {
      setOverlayShow(nextShow);
    },
    [setOverlayShow],
  );

  const [modalShow, setModalShow] = useState(false);

  const onCopytextButtonClick = async () => {
    setModalShow(true);
  };

  return (
    <>
      <OverlayTrigger
        rootClose
        trigger="click"
        show={overlayShow}
        placement={"auto-end"}
        onToggle={toggleHandler}
        overlay={
          <Popover id={`popover-positioned-left`} className="share-button">
            <Popover.Title>Publication options</Popover.Title>
            <Popover.Content className="p-0">
              <ShareContextMenu
                dispatch={dispatch}
                publication={publication}
                handleHide={handleHideHandler}
                onCopytextButtonClick={onCopytextButtonClick}
              ></ShareContextMenu>
            </Popover.Content>
          </Popover>
        }
      >
        <Fa icon="fas fa-ellipsis-v" className="ml-auto mr-0 float-right cursor-pointer pt-2" />
      </OverlayTrigger>

      {modalShow && <CopyTextModal modalShow={modalShow} setModalShow={setModalShow} publication={publication} />}
    </>
  );
};
